import React from "react";
import TriangleRightIcon from "./icons/TriangleRightIcon.jsx";
import AppletIcon from "./AppletIcon.jsx";
import { SiteInfoAppletData } from "./Body.jsx";

export default function Applet({ applet: { title, iconUrl } }: { applet: SiteInfoAppletData }) {
  return (
    <div className='tw-flex tw-items-center tw-gap-7 tw-pb-3 tw-pt-3 tw-text-lg tw-text-[#212121]'>
      <AppletIcon url={iconUrl} />
      <span className='tw-flex-grow'>{title}</span>
      <TriangleRightIcon className='tw-fill-[#898989]' />
    </div>
  );
}
